module.exports = __webpack_public_path__ + "static/media/Heart of Ocean.676d7c01.png";